import React, {FunctionComponent, useContext, useState} from "react";
import {ChallengeProtocolData} from "/src/domain/challenges/ChallengeProtocolData";
import {User} from '/src/domain/shared/User';
import {ButtonBase} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {AuditIcon, AskQuestionIcon, FileAppealIcon} from "/src/ui/shared/challengeProtocol/UserFeedbackIcons"
import cs from "classnames";
import {theme} from "/src/assets/theme";
import {useTranslation} from "react-i18next"
import {PageContext, PageContextProps} from "/src/contexts/Page";

interface UserFeedbackButtonsData {
    challengeProtocol: ChallengeProtocolData;
    currentUser?: User;
    handleAudit: () => void;
    handleQuestion: () => void;
    handleAppeal: () => void;
}

const UserFeedbackButtons: FunctionComponent<UserFeedbackButtonsData> = ({
                                                                             challengeProtocol,
                                                                             currentUser,
                                                                             handleAudit,
                                                                             handleQuestion,
                                                                             handleAppeal
                                                                         }) => {
    const {t} = useTranslation()
    const classes = useStyles();
    const {pageConfig} = useContext(PageContext) as PageContextProps;

    return (
        <div className={classes.btnGruop}>
            <ButtonBase className={classes.btn} onClick={handleAudit}>
                <AuditIcon/>
                {t('auditTracks')}
            </ButtonBase>
            {!pageConfig?.isCommunityChatDisabled && <ButtonBase className={classes.btn} onClick={handleQuestion}>
                <AskQuestionIcon/>
                {t('askQuestion')}
            </ButtonBase>}
            {/* {!pageConfig?.isAppealDisabled &&
                <ButtonBase className={cs(classes.btn, classes.btnAppeal)} onClick={handleAppeal}>
                    <FileAppealIcon/>
                    {t('appeal')}
                </ButtonBase>} */}
        </div>
    )
}

const useStyles = makeStyles(muiTheme => ({
    btnGruop: {
        padding: '1rem 0',
        margin: '0 1.5rem',
        backgroundColor: theme.primarySurfaceColor,
        borderRadius: '10px',
        display: 'flex',
        justifyContent: 'space-around'

    },
    btn: {
        width: '4rem',
        borderRadius: '10px',
        color: muiTheme.palette.primary.main,
        fontWeight: 500,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start'
    },
    btnAppeal: {
        width: '4.6rem',
    }
}))

export default UserFeedbackButtons